<mat-toolbar>
  <h2 class="user-name" fxFlex>{{ (user$ | async)?.name }}</h2>

  <button mat-icon-button [matMenuTriggerFor]="profileMenu">
    <mat-icon>more_vert</mat-icon>
  </button>

  <mat-menu #profileMenu="matMenu">
    <a mat-menu-item routerLink="profile-edit">{{ 'header.editProfile' | translate }}</a>
    <button mat-menu-item (click)="logout()">{{ 'header.logout' | translate }}</button>
  </mat-menu>
</mat-toolbar>

<mat-nav-list *ngIf="company$ | async as company">
  <ng-container *ngFor="let item of menuDef.items">
    <ng-container *ngIf="!item.condition || item.condition(company, injector)">
      <ng-container *ngIf="!$any(item).children; else buttonWithChildren">
        <a mat-list-item [routerLink]="$any(item).routerLink" routerLinkActive="active" [ampTrack]="item.ampTrack ?? null">
          {{ item.name | translate }}
        </a>
      </ng-container>

      <ng-template #buttonWithChildren>
        <mat-expansion-panel (opened)="onExpansionPanelOpened(item)">
          <mat-expansion-panel-header expandedHeight="48px" [ampTrack]="item.ampTrack ?? null">
            {{ item.name | translate }}
          </mat-expansion-panel-header>

          <mat-nav-list>
            <!-- Grouped Reports for A/B test - Mobile always shows vertical layout -->
            <ng-container *ngIf="item.name === 'header.reports' && showGroupedReports; else defaultSidenavContent">
              <div class="reports-menu-grouped">
                <ng-container *ngFor="let group of groupedReports">
                  <ng-container *ngIf="hasVisibleReports(group, company)">
                    <div class="menu-label">{{ group.name | translate | uppercase }}</div>
                    <ng-container *ngFor="let report of getVisibleReports(group, company)">
                      <a mat-list-item [routerLink]="$any(report).routerLink" routerLinkActive="active"
                        [ampTrack]="$any(report).ampTrack ?? null"
                        [fragment]="$any(report).fragment"
                        [routerLinkActiveOptions]="$any(report).fragment ? customRouterLinkActiveOptions : {'exact': false}"
                        (click)="onReportItemClick(report, group)">
                        {{ report.name | translate }}
                        <ng-container *ngIf="report.badge">
                          <ng-container *ngIf="$any(report.badge).length; else singleReportBadge">
                            <ng-container *ngFor="let badgeItem of $any(report.badge)">
                              <ng-template
                                *ngTemplateOutlet="badge; context: { icon: badgeItem.icon, iconTooltip: badgeItem.iconTooltip, text: badgeItem.text, condition: badgeItem.condition, tooltip: badgeItem.tooltip, color: badgeItem.color }"></ng-template>
                            </ng-container>
                          </ng-container>
                          <ng-template #singleReportBadge>
                            <ng-template
                              *ngTemplateOutlet="badge; context: { icon: $any(report.badge).icon, iconTooltip: $any(report.badge).iconTooltip, text: $any(report.badge).text, condition: $any(report.badge).condition, tooltip: $any(report.badge).tooltip, color: $any(report.badge).color }"></ng-template>
                          </ng-template>
                        </ng-container>
                      </a>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </div>
            </ng-container>

            <!-- Default sidenav content (non-grouped) -->
            <ng-template #defaultSidenavContent>
              <ng-container *ngFor="let sub of $any(item).children">
                <ng-container *ngIf="!sub.condition || sub.condition(company, injector)">
                  <ng-container *ngIf="sub.routerLink; else menuLabel">

                    <a mat-list-item [routerLink]="sub.routerLink" routerLinkActive="active" [ampTrack]="$any(sub).ampTrack ?? null" [fragment]="sub.fragment"
                      [routerLinkActiveOptions]="sub.fragment ? customRouterLinkActiveOptions : {'exact': false}">
                      {{ sub.name | translate }}
                      <ng-container *ngIf="sub.badge">
                        <ng-container *ngIf="sub.badge.length; else singleBadge">
                          <ng-container *ngFor="let item of sub.badge">
                            <ng-template
                              *ngTemplateOutlet="badge; context: { icon: item.icon, iconTooltip: item.iconTooltip, text: item.text, condition: item.condition, tooltip: item.tooltip, color: item.color }"></ng-template>
                          </ng-container>
                        </ng-container>
                        <ng-template #singleBadge>
                          <ng-template
                            *ngTemplateOutlet="badge; context: { icon: sub.badge.icon, iconTooltip: sub.badge.iconTooltip, text: sub.badge.text, condition: sub.badge.condition, tooltip: sub.badge.tooltip, color: sub.badge.color }"></ng-template>
                        </ng-template>
                      </ng-container>
                    </a>
                  </ng-container>
                  <ng-template #menuLabel>
                    <div class="menu-label">{{ sub.name | translate }}</div>
                  </ng-template>
                </ng-container>
              </ng-container>
            </ng-template>

            <ng-template #badge let-condition="condition" let-text="text" let-icon="icon" let-iconTooltip="iconTooltip"
              let-tooltip="tooltip" let-color="color">
              <div *ngIf="!condition || condition(company, injector)" [matTooltip]="tooltip | translate"
                class="sidenav-badge" [class.beta]="color === 'beta'">
                <mat-icon *ngIf="icon" class="badge-icon" [matTooltip]="iconTooltip | translate">{{ icon
                  }}</mat-icon>
                <div *ngIf="text" class="badge-text">{{ text | translate }}</div>
              </div>
            </ng-template>
          </mat-nav-list>
        </mat-expansion-panel>
      </ng-template>
    </ng-container>
  </ng-container>
</mat-nav-list>
